/**
 * Amazon ASIN helpers shared between the backend and frontend apps so the
 * validation rule stays in lockstep across the codebase.
 */

/** ASINs are ten characters: a "B" followed by nine alphanumerics. */
export const AMAZON_ASIN_REGEX = /^(B[a-zA-Z0-9]{9})$/;

/** Returns true when `input` is a valid Amazon ASIN. */
export const isValidAmazonAsin = (input: string): boolean =>
  typeof input === "string" && AMAZON_ASIN_REGEX.test(input);
